import React from "react";
import PropTypes from "prop-types";
import { Component } from "react";
import HelperContent from "../../helperContent/HelperContent";
import QuestionLabel from "../../question/QuestionLabel";
import QuestionOption from "../../question/QuestionOption";

class PhoneExaminationResults extends Component {
    render() {
        let question = this.props.question;
        let store = this.props.store;
        let result = store.getState().resultData;
        let message;
        let showOptions = (
            <div>
                <ul className="w3-ul w3-border w3-padding-small w3-margin-top">
                    {question.options.map(option => (
                        <li className="question-option w3-xlarge w3-center" key={option.itemID}>
                            <QuestionOption option={option} onClick={() => store.dispatch({ type: option.action, selectedOption: option })} />
                        </li>
                    ))}
                </ul>
            </div>);

        if (result && result.value) {
            switch (result.value) {
                case "cracked":
                    message = "We have detected suitable damage to your phone. Your claim will be reviewed.";
                    break;
                case "no phone":
                    message = "We did not detect a mobile phone in your photo. Please call to continue this claim.";
                    break;
                case "intact":
                    message = "We did not detect suitable damage to your phone. Please call to continue your claim.";
                    break;
                default:
                    message = "We are unable to determine the state of your phone. Please call to continue your claim.";
                    break;
            }
        }
        
        return (
            <div className="form w3-header w3-animate-opacity">
                <QuestionLabel question={question} store={store}/>
                <HelperContent question={question} />

                <div id="myText" className="w3-panel w3-large w3-center w3-opacity">
                    {message}
                </div>

                {showOptions}
            </div>
        )
    }
};

PhoneExaminationResults.propTypes = {
    question: PropTypes.object,
    store: PropTypes.object
};

export default PhoneExaminationResults;
